import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Title from './dev/Title';
import Subtitle from './dev/Subtitle';
import Input from './dev/Input';
import IdentitySelect from './dev/IdentitySelect';
import LoadingSpinner from '../dev/LoadingSpinner'
import EditIcon from '../icon/EditIcon'
import CheckIcon from '../icon/CheckIcon'

const { REACT_APP_URI = '/' } = process.env
class AgencyAdmin extends Component {
    state={
        companyInfo: '',
        isLoading: true,
        isContentLoading: false,
        isEdit: false,
        isDelete: false,
        isInvite: false,
        isExit: false,
        isSuccesstoExit: false,
        deleteItemId: '',
        deleteItemEmail: '',
        invitedEmail: '',
        editedCompany: '',
        error: {
            inviteError: '',
            deleteError: '',
            exitError:'',
        }
    }
    componentDidMount = () => {
        this.getCompanyInfo()
    }
    getCompanyInfo = (isEdit=false) => {
        this.setState({ isLoading: true, isEdit: isEdit, isDelete: false, isInvite: false, isContentLoading: false, error: { inviteError: '', deleteError: ''} })
        fetch(`${REACT_APP_URI}/accounts/showCompanyInfo/`, { credentials: 'include' })
            .then(res => res.json())
            .then(companyInfo => this.setState({ companyInfo, isLoading: false, editedCompany: companyInfo.company }))
    }
    toggleEdit = value => this.setState({ isEdit: value, isDelete: false, editedCompany: this.state.companyInfo.company })
    toggleDelete = value => this.setState({ isEdit: true, isDelete: value })
    toggleInvite = value => this.setState({ isInvite: value })
    toggleExit = value => this.setState({ isExit: value })
    kickUser = deleteItemId => {
        const { messages, user: { token } } = this.props
        const { getCompanyInfo } = this
        this.setState({ isContentLoading: true })
        fetch(`${REACT_APP_URI}/accounts/kickUser/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ userId: deleteItemId })
        })
        .then(res => {
            const { status } = res
            if (status === 200) getCompanyInfo(true)
            else if (status === 704) this.setState({ error: { ...this.state.error, deleteError: messages.user_agency_user_is_invited }})
            else this.setState({ error: { ...this.state.error, deleteError: messages.payment_unknown_error } })
        })
    };
    input = condition => e => this.setState({ [condition]: e.target.value})
    exitAgency = () => {
        const { messages, user: { token } } = this.props
        this.setState({ isContentLoading: true })
        fetch(`${REACT_APP_URI}/accounts/exitFromAgency/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify()
        })
        .then(res => {
            const { status } = res
            if (status === 200) this.setState({exitError: messages.user_agency_exit_success, isContentLoading: false, isSuccesstoExit:true})
            else if (status === 400) this.setState({exitError: messages.user_agency_last_admin, isContentLoading: false, isSuccesstoExit:true})
            else this.setState({exitError: messages.payment_unknown_error, isContentLoading: false })
        })
    }
    inviteSubmit = () => {
        const { messages, user: { token } } = this.props
        const { getCompanyInfo, state: { invitedEmail } } = this
        this.setState({ isContentLoading: true, inviteError: '' })
        fetch(`${REACT_APP_URI}/accounts/addUsers/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ email: invitedEmail })
        })
        .then(res => {
            const { status } = res
            if (status === 200) getCompanyInfo()
            else if (status === 400) this.setState({ error: { ...this.state.error, inviteError: messages.user_agency_no_result}, isContentLoading: false})
            else if (status === 703) this.setState({ error: { ...this.state.error, inviteError: messages.user_agency_user_is_invited}, isContentLoading: false})
            else this.setState({ error: { ...this.state.error, inviteError: messages.payment_unknown_error },isContentLoading: false })
        })
    }
    editCompanySubmit = () => {
        const { messages, user: { token } } = this.props
        const { getCompanyInfo, state: { editedCompany } } = this
        this.setState({ isLoading: true })
        fetch(`${REACT_APP_URI}/accounts/editCompanyName/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ name: editedCompany })
        })
        .then(res => {
            const { status } = res
            if (status === 200) getCompanyInfo()
            else this.setState({ error: { ...this.state.error, inviteError: messages.payment_unknown_error }, isLoading: false })
        })
    }
    idenetitySelect = ({ value = '' }, id, identity) => {
        const { user: { token } } = this.props
        const { companyInfo: { myId}} = this.state
        const { getCompanyInfo } = this
        if( value === identity) return
        this.setState({ isLoading: true })
        fetch(`${REACT_APP_URI}/accounts/changeRole/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ userId: id, role: value })
        })
        .then(res => {
            const { status } = res
            if (status === 200) {
                if (id === myId) window.location.reload()
                else getCompanyInfo(true)
            }
            else this.setState({ isLoading: false})
        })
    }
    renderMail = ({ email }) => <Text>{email}</Text>
    renderIdentity = ({ identity, id }) =>   {
        const { idenetitySelect, state: { isEdit } } = this
        return (
            <React.Fragment>
                {!isEdit && <Text>{identity}</Text>}
                {isEdit && <IdentitySelect id={id} identity={identity} idenetitySelect={idenetitySelect}/>}
            </React.Fragment>
        )
    }
    renderRemove = (message, id, email) => <RemoveContent onClick={() => this.setState({ deleteItemId: id, deleteItemEmail: email, isDelete: true })}>{message}</RemoveContent>
    renderRenoveComfirm = () => {
        const { kickUser, state: { deleteItemId, deleteItemEmail, isDelete, isContentLoading, error: { deleteError } }, props: { messages } } = this
        return (
            <Mask isActive={isDelete}>
                <MaskContent>
                    <Title>{messages.user_agency_confirm_remove}</Title>
                    <Subtitle>{deleteItemEmail}</Subtitle>
                    {isContentLoading && <LoadingSpinner size={'30px'} />}
                    {!isContentLoading && <Error>{deleteError}</Error>}
                    {!isContentLoading && <Footer isActive>
                        <Edit isActive onClick={() => kickUser(deleteItemId)}>{messages.ok}</Edit>
                        <Edit isActive onClick={() => this.setState({ deleteItemId: '', isDelete: false })}>{messages.cancel}</Edit>
                    </Footer>}
                </MaskContent>
            </Mask>
        )
    }
    renderInvite = () => {
        const { input, inviteSubmit, toggleInvite, state: { invitedEmail, isInvite, isContentLoading, error: { inviteError } }, props: {messages} } = this
        return (
            <Mask isActive={isInvite}>
                <MaskContent>
                    <Title>{messages.user_agency_invite}</Title>
                    <Input onInput={input('invitedEmail')} value={invitedEmail} type="email" name="email"
                        onKeyPress={e => e.key === "Enter" && inviteSubmit()}
                        placeholder={messages.user_agency_invite_email}
                        margin="10px 0 0 0"
                    />
                    {isContentLoading && <LoadingSpinner size={'30px'}/>}
                    {!isContentLoading && <Error>{inviteError}</Error>}
                    {!isContentLoading && <Footer isActive>
                        <Edit isActive onClick={() => inviteSubmit()}>{messages.ok}</Edit>
                        <Edit isActive onClick={() => toggleInvite(false)}>{messages.cancel}</Edit>
                    </Footer>}
                </MaskContent>
            </Mask>
        )
    }
    renderExit = () => {
        const { exitAgency, toggleExit, props: {messages},state: { isExit,isContentLoading,exitError,isSuccesstoExit} } = this
        return (
            <Mask  isActive={isExit}>
                <MaskContentforExit>
                    <Title>{messages.user_agency_out}</Title>
                    {isContentLoading && <LoadingSpinner size={'30px'} />}
                    {!isContentLoading && <Error>{exitError}</Error>}
                    {!isContentLoading && !isSuccesstoExit && <Footer isActive>
                        <Edit isActive onClick={() => exitAgency()}>{messages.user_agency_exit}</Edit>
                        <Edit isActive onClick={() => toggleExit(false)}>{messages.user_chancel_deny}</Edit>
                    </Footer>}
                    {isSuccesstoExit && <Footer isActive >
                        <Edit isActive onClick={() => window.location.reload()}>{messages.ok}</Edit>
                    </Footer>}
                </MaskContentforExit>
            </Mask>
        )
    }
    render() {
        const { companyInfo: { company, members, IM, remainSeats }, isLoading, isEdit, editedCompany } = this.state
        const { messages } = this.props
        const { input, editCompanySubmit, toggleEdit, toggleInvite, toggleExit, renderMail, renderIdentity, renderRemove, renderRenoveComfirm, renderInvite, renderExit } = this
        return (
            <Container>
                {isLoading && <LoadingSpinner />} 
                {!isLoading && renderRenoveComfirm()}
                {!isLoading && renderInvite()}
                {!isLoading && renderExit()}
                {!isLoading && <React.Fragment>
                    <Wrap>
                        <Content between>
                            {!isEdit && 
                                <Content alignCenter>
                                    <Title>{company}</Title>
                                    <Edit isActive onClick={()=> toggleExit(true)}>{messages.user_agency_exit}</Edit>
                                </Content>  }
                            {isEdit && 
                                <Content alignCenter>
                                    <TitleInput
                                        onInput={input('editedCompany')}
                                        value={editedCompany}
                                        onKeyPress={e => e.key === "Enter" && editCompanySubmit()}
                                        type="text" placeholder={messages.user_agency_team_name}
                                    />
                                    <Edit isActive onClick={()=> editCompanySubmit()}>{messages.ok}</Edit>
                                </Content>}  
                            
                            <div>{messages.user_agency_seat}{remainSeats}</div>
                        </Content>
                    </Wrap>
                    <Wrap regularTop>
                        {IM === 'Admin' && <EditIconWrap isActive={!isEdit} onClick={() => toggleEdit(true)}>
                            <EditIcon width={15} />
                        </EditIconWrap>}
                        {IM === 'Admin' && <EditIconWrap isActive={isEdit} onClick={() => toggleEdit(false)}>
                            <CheckIcon isCheck />
                        </EditIconWrap>}
                        <Content between maxHeight>
                            <Content start>
                                <Mail>
                                    <ContentNav>{messages.userInfo_email}</ContentNav>
                                    {members.map( i => renderMail(i))}
                                </Mail>
                                <Identity>
                                    <ContentNav>{messages.userInfo_identity}</ContentNav>
                                    {members.map(i => renderIdentity(i))}
                                </Identity>
                            </Content>
                            <Content start>
                                <Remove>
                                    <ContentNav opacity>{messages.delete}</ContentNav>
                                    {isEdit && members.map(i => renderRemove(messages.delete, i.id, i.email))}
                                </Remove>
                            </Content>
                        </Content>
                        <Footer isActive={IM === 'Admin' && !isEdit}>
                            <Edit large isActive={remainSeats > 0} onClick={() => (remainSeats > 0) && toggleInvite(true)}>{messages.user_agency_invite}</Edit>
                            <Edit large onClick={() => this.props.history.push('/AgencyPayment/Management')} isActive>{messages.user_agency_add_seat}</Edit>
                        </Footer>
                    </Wrap>
                </React.Fragment>}
            </Container>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages,
    }
}
export default withRouter(connect(mapStateToProps)(AgencyAdmin));
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 900px;
    margin-top: 30px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);  
    @media (max-width: 900px){
        width: calc(100% - 40px);
        margin: 20px 20px 0 20px;
    }         
    a {
        &:focus {
            text-decoration: none 
        }
    } 
`

const Wrap = styled.div`
    position: relative;
    width: 100%;
    padding: 48px;
    border-bottom: 1px solid #e6e6e6;
    ${({ regularTop }) => regularTop ? 'padding: 24px 48px; border-bottom: 0;' : ''}
    &:last-child {
        border-bottom: 0;
    }
    @media (max-width: 900px){
        padding: 24px;
    } 
`

const Content = styled.div`
    display: flex;
    /* align-items: center; */
    ${({ maxHeight }) => maxHeight ? 'max-height: 22.5rem; overflow: scroll' : ''}
    ${({ between }) => between ? 'justify-content: space-between;' : ''}
    ${({ alignCenter }) => alignCenter ? 'align-items: center' : ''}
    ${({ start }) => start ? 'align-items: flex-start' :''}
    @media (max-width: 900px){
    }
`
const ContentNav = styled.div`
    ${({ opacity }) => opacity ? 'opacity: 0' : ''};
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
`
const ExtendSubtitle = Subtitle.extend`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 20px;
    /* margin-bottom: 2rem; */
    @media (max-width: 900px){
        font-size: 16px;
        margin-right: 10px;
    }
`
const Edit = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 0 5px;
    ${({ large }) => large ? 'margin: 0 16px;' : ''}
    margin: 0 8px;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    opacity: .8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
    ${({ isActive }) => isActive ? '' : 'background-color: #a0a0a0; cursor: not-allowed;'}
    &:hover {
        opacity: 1;
    }
`
const EditIconWrap = styled.div`
    position: absolute;
    display: ${props => props.isActive ? 'flex' : 'none'};
    align-items: center;
    justify-content: center;
    top: 0;
    right: 0;
    width: 48px;
    height: 48px;
    /* top: 24px;
    right: 24px;
    transform: translate(50%, -50%); */
    cursor: pointer;
`
const Text = styled.div`
    display: flex;
    align-items: center;
    height: 34px;
    margin-bottom: .4rem;
`
const Mail = ExtendSubtitle.extend`
`
const Identity = ExtendSubtitle.extend`
    width: 60px;
`
const Remove = ExtendSubtitle.extend`
    position: relative;
    width: 40px;    
    color: #de0606;
`
const RemoveContent = Text.extend`
    cursor: pointer;
`
const Mask = styled.div`
    position: absolute;
    visibility: ${props => props.isActive ? 'visible' : 'hidden'};
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    transition: all .2s ease-in-out;
    background-color: rgba(0,0,0,.6);
    overflow: hidden;
    /* filter blur 效果設在 Background component中 */
`
const MaskContent = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    bottom: 48px;
    background-color: #fff;
    padding: 24px 48px;
`
const MaskContentforExit = styled.div`
    position: absolute;
    top: 48px;
    background-color: #fff;
    padding: 24px 48px;
`
const Footer = styled.div`
    display: ${props => props.isActive ? 'flex' : 'none'};
    justify-content: center;
    margin-top: 20px;
`
const Error = styled.div`
    /* margin-bottom: 24px; */
    color: #de0606;
`
const TitleInput= styled(Input)`
    font-size: 34px;
    font-weight: 500;
`



// WEBPACK FOOTER //
// ./src/UserInfo/AgencyAdmin.js